import { GridRenderEditCellParams, useGridApiContext } from "@mui/x-data-grid";
import PosAliasInput from "./PosAliasInput";
import { useItemAliases } from "../hooks/useItemAliases";
import { Item } from "../util/Item";

type CatalogItem = {
	id: number;
	ItemName?: string;
};

interface Props extends GridRenderEditCellParams<Item> {
	catalogItems: CatalogItem[];
}

const PosAliasEditCell = ({ id, field, value, row, catalogItems }: Props) => {
	const apiRef = useGridApiContext();
	const { data, loading } = useItemAliases(row.id);

	const aliasValue = String(value ?? row.item ?? "");

	const applyAlias = (alias: string) => {
		apiRef.current.setEditCellValue({ id, field, value: alias });
	};

	return (
		<PosAliasInput
			value={aliasValue}
			onChange={applyAlias}
			itemId={row.id}
			catalogName={data.catalog_name}
			aliases={data.aliases}
			loading={loading}
			catalogItems={catalogItems}
			onCatalogMatch={(_itemId, itemName) => applyAlias(itemName)}
			size="small"
			variant="standard"
			autoFocus
			onFocus={(e) => e.target.select()}
		/>
	);
};

export default PosAliasEditCell;